// Utility functions
import AppConfig, { IS_DEVELOPMENT_ENV } from '@/AppConfig';
import { queryClient } from '@/context/CombinedProvider';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { getCurrentIstDate, isWithinIstWindow } from './time';

export type JWTPayload = {
  exp?: number;
  memberId: string;
  organisationId: string;
  emailId: string;
  source: 'MEMBERS' | 'IAM';
  d2cUserId: string;
};
function isTokenExpired(jwtPayload: JWTPayload): boolean {
  const now = Date.now() / 1000; // current time in seconds
  return !!(jwtPayload.exp && jwtPayload.exp < now);
}

export function decodeAuthToken(
  token: string = Cookies.get(AppConfig.JWT_TOKEN_COOKIE_NAME) as string,
): JWTPayload | null {
  if (token) {
    const decoded = jwtDecode<JWTPayload>(token);
    if (decoded && !isTokenExpired(decoded)) {
      return decoded;
    }
    return null;
  }
  return null;
}

export const redirectToPlumApp = (href: string) => () => {
  // window.dev.i('Redirecting to Plum App', getPlumAppUrl(href));
  window.location.href = getPlumAppUrl(href);
};

export const removeJwtToken = async () => {
  await queryClient.invalidateQueries();
  Cookies.remove(AppConfig.JWT_TOKEN_COOKIE_NAME, {
    domain: IS_DEVELOPMENT_ENV ? 'localhost' : '.plumhq.com',
    path: '/',
  });
};

export const getPlumAppUrl = (href: string) => {
  return `${AppConfig.PLUM_APP_HOST_URL}${href}`;
};

export const track = (event: string, properties?: Record<string, unknown>) => {
  window.dev?.i('Track event:', event, properties);
};

track.identifyUserToAnalytics = (user: unknown) => {
  window.dev?.i('Identify user:', user);
};

export { getCurrentIstDate, isWithinIstWindow };

export default {
  decodeAuthToken,
  redirectToPlumApp,
  track,
  getCurrentIstDate,
  isWithinIstWindow,
};
